import { render, staticRenderFns } from "./volunteerDraft.vue?vue&type=template&id=6aa03808&scoped=true"
import script from "./volunteerDraft.vue?vue&type=script&lang=js"
export * from "./volunteerDraft.vue?vue&type=script&lang=js"
import style0 from "./volunteerDraft.vue?vue&type=style&index=0&id=6aa03808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa03808",
  null
  
)

export default component.exports